import { SpaceScanData } from "../../../passapp-sdk/types/spaceTypes";
import { RoutePaths } from "../../../utils/Items";
import { setLastSpaceScan } from "../store/reservationScanStore";
import { ReservationResultKey } from "../ReservationResult/reservationResults";

type History = { push: (path: string) => void };

export const reservationResultPath = (state: ReservationResultKey | string) =>
  `${RoutePaths.ReservationResult}?state=${encodeURIComponent(state)}`;

export const goToReservationResult = (history: History, scan: SpaceScanData) => {
  setLastSpaceScan(scan);
  history.push(reservationResultPath(scan.status));
};

export const goToReservationScan = (history: History) => {
  history.push(RoutePaths.ReservationScan);
};

export const goToReservationsHome = (history: History) => {
  history.push(RoutePaths.Reservations);
};
